module.exports = __webpack_public_path__ + "img/video-cover-audio-identity.38f49fef.jpg";